import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

import Hero from "@components/Hero/Hero"
import { TabsDIV } from "@components/Tabs/Tabs.styles"

export const InterviewBuilderHeroHERO = styled(Hero)`
  background: var(--color--cobalt-100);
  text-align: center;
  overflow: hidden;

  .hero-content {
    position: relative;
    margin: var(--spacing--M) auto;
  }

  h1 {
    position: relative;
    z-index: 1;
    width: fit-content;
    margin: 0 auto;
  }

  .illo-left,
  .illo-right {
    display: none !important;

    ${MEDIA_QUERIES.L} {
      display: block !important;
      position: absolute !important;
      top: -1rem;
      width: 15rem;
    }
  }

  .illo-left {
    right: calc(100% - var(--spacing--XL));
  }

  .illo-right {
    left: calc(100% - var(--spacing--XL));
  }

  .illo-mobile-left,
  .illo-mobile-right {
    display: block !important;
    position: absolute !important;
    width: 5rem;

    ${MEDIA_QUERIES.L} {
      display: none !important;
    }
  }

  .illo-mobile-left {
    top: 12rem;
    right: calc(100% - var(--spacing--XL));
  }

  .illo-mobile-right {
    top: -2rem;
    left: calc(100% - var(--spacing--XL));
  }

  p {
    position: relative;
    z-index: 1;
    max-width: 895px;
    margin: 0 auto;
    font-size: var(--font-size--L);
  }

  .TextLink {
    display: block;
    color: var(--color--action-default);
    font-size: inherit;

    ${MEDIA_QUERIES.M} {
      display: inline-block;
    }
  }

  .Tabs--Items {
    position: relative;
    border-bottom: 1px solid var(--color--clay-300);;
    margin-bottom: var(--spacing--S);

    .is-content-page& {
      margin-bottom: var(--spacing--M);
    }
  }

  .back-link {
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    margin-left: -10px;
    height: 42px;
    z-index: 2;
    color: var(--color--charcoal-700);
    transition: transform 0.2s;

    ${MEDIA_QUERIES.S} {
      width: 40px;
      margin-left: 0;
      padding: 0;
    }

    ${MEDIA_QUERIES.L} {
      width: 60px;
      height: 65px;
    }

    &:hover {
      color: var(--color--charcoal-800);
      transform: translateX(-5%);
    }
  }
`
